import React from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Autocomplete from "@mui/material/Autocomplete";
import MuiLink from "@mui/material/Link";

// @mui icons
import Icon from "@mui/material/Icon";

// Settings page components
import FormField from "layouts/pages/account/components/FormField";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import AddBuyerPopup from "examples/Popups/AddBuyer";
import AddPopupDate from "examples/Popups/AddDate";
import SimplePopup from "examples/Popups/SimplePopup";
import generateRandomId from "./functions/generateRandomId";

function AusbildungCard({ product, index, dates, displayedBuyer, displayedDay, handleDayChange, changeBuyerAusbildung, addBuyer, deleteBuyer, updateTotalSpace }) {
  const [dateIndex, setDateIndex] = React.useState(0);
  const [popupAddNewBuyer, setPopupAddNewBuyer] = React.useState(false);
  const [newBuyer, setNewBuyer] = React.useState({ buyerId:"", firstName:"", lastName:"", email:"", phone:"" });
  const [popupDeleteBuyer, setPopupDeleteBuyer] = React.useState(false);
  const [popupDatumHinzufuegen, setPopupDatumHinzufuegen] = React.useState(false);
  const [visibleTotalSpace, setVisibleTotalSpace] = React.useState(false);
  const [totalSpace, setTotalSpace] = React.useState(0);

  const handleSelectDate = (newValue) => {
    console.log(displayedDay);
    console.log(dateIndex);
    console.log(index);
    
    for (let i = 0; i < product.properties[0].dates.length; i++) {
      if (product.properties[0].dates[i].date === newValue) {
        setDateIndex(i);
        handleDayChange(i);
        changeBuyerAusbildung("");
        break;
      }
    }
  };

  const handleSelectBuyer = (newValue) => {
    changeBuyerAusbildung(newValue);
  };

  const saveNewBuyer = async () => {
    let tempNewBuyer = { ...newBuyer };
    const newBuyerId = generateRandomId(17);
    tempNewBuyer["buyerId"] = "b-" + newBuyerId;
    await addBuyer(tempNewBuyer, index, dateIndex);
    setNewBuyer({ firstName:"", lastName:"", email:"", phone:"" });
    setPopupAddNewBuyer(false)
  }

  const cancelNewBuyer = () => {
    setNewBuyer({ firstName:"", lastName:"", email:"", phone:"" });
    setPopupAddNewBuyer(false)
  }

  const handleNewBuyer = (e, key) => {
    let tempBuyer = { ...newBuyer };
    tempBuyer[key] = e.target.value;
    setNewBuyer(tempBuyer);
  }

  const openDeleteBuyerPopup = () => {
    setPopupDeleteBuyer(true)
  }
  
  const acceptDeleteBuyer = () => {
    deleteBuyer(displayedBuyer.buyerId, index, dateIndex)
    setPopupDeleteBuyer(false)
  }


  const editTotalSpace = () => {
    
    if (product.properties[0].dates.length > 0 && displayedDay!= undefined) {
      if (visibleTotalSpace) {
        updateTotalSpace(totalSpace, index, dateIndex);
        setTotalSpace(totalSpace);
        setVisibleTotalSpace(false);
      } else {
        setTotalSpace(product.properties[0].dates[dateIndex].totalSpace);
        setVisibleTotalSpace(true);
      }
    } else {
      setPopupDatumHinzufuegen(true);
    }
  }

  const handleTotalSpace = (e) => {
    const value = e.target.value;
    // Allow only numbers
    if (/^\d+$/.test(value)) {
      setTotalSpace(parseInt(value, 10));
    }
  }

  const kaeuferHinzufügen = () => {
    if (product.properties[0].dates.length > 0) {
      setPopupAddNewBuyer(true);
    } else {
      setPopupDatumHinzufuegen(true);
    }
  }

  return (
    <Card>
      {popupAddNewBuyer &&
        <AddBuyerPopup
          content={newBuyer}
          handleContent={handleNewBuyer}
          buttonSpeichern={saveNewBuyer}
          buttonAbbrechen={cancelNewBuyer}
        />
      }
      {popupDeleteBuyer &&
        <SimplePopup
          title="Käufer sicher löschen?"
          description="Haben sie den Käufer kontaktiert?"
          buttonLableLeft="Ja"
          buttonLableRight="Nein"
          buttonFunctionLeft={acceptDeleteBuyer}
          buttonFunctionRight={(e) => setPopupDeleteBuyer(false)}
        />
      }
      {popupDatumHinzufuegen &&
        <SimplePopup
          title="Fügen Sie ein Datum hinzu"
          description="Es gibt kein Datum fügen sie erst eins hinzu"
          buttonLableLeft=""
          buttonLableRight="Schließen"
          buttonFunctionLeft={(e) => e.prevent.default}
          buttonFunctionRight={(e) => setPopupDatumHinzufuegen(false)}
        />
      }
      <MDBox p={3}>
        <MDTypography
          display="inline"
          variant="h4"
          textTransform="capitalize"
          fontWeight="bold"
        >
          {product.title}
        </MDTypography>
        <MDBox my={2} display="flex" flexDirection="row" alignItems="center">
          <Autocomplete
            options={dates[index]}
            value={displayedDay}
            disableClearable
            onChange={(event, newValue) => {
              handleSelectDate(newValue);
            }}
            renderInput={(params) => (
              <FormField
                {...params}
                label="Datum"
                InputLabelProps={{ shrink: true }}
              />
            )}
            style={{ minWidth: "150px" }}
          />
        </MDBox>
        <MDBox ml={2}>
          <MDBox mt={1} display="flex" flexDirection="row" alignItems="center" gap={2}>
            <MDTypography variant="body2" component="p" color="text">
              Plätze:
            </MDTypography>
            <MDBox display="flex" flexDirection="row" alignItems="center" >
              {visibleTotalSpace ? (
                <MDBox display="flex" flexDirection="row" alignItems="center">
                  <MDInput
                    value={totalSpace}
                    onChange={(e) => handleTotalSpace(e)}
                    style={{
                      minWidth: "80px",
                      maxWidth: "80px"
                    }}
                  />
                  <MDBox ml={1} onClick={editTotalSpace} style={{ cursor: "pointer" }}>
                    <Icon fontSize="small">save</Icon>
                  </MDBox>
                </MDBox>
              ) : (
                <MDBox display="flex" flexDirection="row" alignItems="center">
                    {displayedDay!=undefined && (
                      <MDTypography px={2} variant="body2" component="p" color="text">
                        {product.properties[0].dates.length >0 ? product.properties[0].dates[dateIndex].totalSpace : "15"}
                      </MDTypography>
                    )}
                  <MDBox ml={1} onClick={editTotalSpace} style={{ cursor: "pointer" }}>
                    <Icon fontSize="small">edit</Icon>
                  </MDBox>
                </MDBox>
              )}
            </MDBox>
          </MDBox>
          <MDBox mt={1} display="flex" flexDirection="row" alignItems="center" gap={2}>
            <MDTypography variant="body2" component="p" color="text">
              Reserviert:
            </MDTypography>
            {displayedDay!=undefined && (
              <MDTypography variant="body2" component="p" color="text">
                {product.properties[0].dates[dateIndex].reserved.length}
              </MDTypography>
            )}
          </MDBox>
          <MDBox mt={1} display="flex" flexDirection="row" alignItems="center">
            <Autocomplete
              options={product.properties[0].dates.length >0 ? product.properties[0].dates[dateIndex].reserved : []}
              disableClearable
              value={displayedBuyer ? displayedBuyer.buyerId : ""}
              onChange={(event, newValue) => {
                handleSelectBuyer(newValue);
              }}
              renderInput={(params) => (
                <FormField
                  {...params}
                  label="Käufer"
                  InputLabelProps={{ shrink: true }}
                />
              )}
              style={{ minWidth: "250px" }}
            />
            <MDButton mt={1} onClick={kaeuferHinzufügen} style={{ color: "green" }}>
              Käufer hinzufügen
            </MDButton>
          </MDBox>
          {displayedBuyer && (
            <MDBox ml={3}>
              <MDBox mt={2} display="flex" flexDirection="row" alignItems="center" gap={2}>
                <MDTypography variant="body2" component="p" color="text">
                  Vorname:
                </MDTypography>
                <MDTypography variant="body2" component="p" color="text">
                  {displayedBuyer.firstName}
                </MDTypography>
              </MDBox>
              <MDBox mt={1} display="flex" flexDirection="row" alignItems="center" gap={2}>
                <MDTypography variant="body2" component="p" color="text">
                  Nachname:
                </MDTypography>
                <MDTypography variant="body2" component="p" color="text">
                  {displayedBuyer.lastName}
                </MDTypography>
              </MDBox>
              <MDBox mt={1} display="flex" flexDirection="row" alignItems="center" gap={2}>
                <MDTypography variant="body2" component="p" color="text">
                  E-Mail:
                </MDTypography>
                <MDTypography variant="body2" component="p" color="text">
                  {displayedBuyer.email}
                </MDTypography>
              </MDBox>
              <MDBox mt={1} display="flex" flexDirection="row" alignItems="center" gap={2}>
                <MDTypography variant="body2" component="p" color="text">
                  Telefon:
                </MDTypography>
                <MDTypography variant="body2" component="p" color="text">
                  {displayedBuyer.phone}
                </MDTypography>
              </MDBox>
              <MDButton mt={1} onClick={() => openDeleteBuyerPopup()} style={{ color: "red"}}>
                Käufer stornieren
              </MDButton>
            </MDBox>
          )}
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Typechecking props for the AusbildungCard
AusbildungCard.propTypes = {
  handleDisplayProduct: PropTypes.func,
};

export default AusbildungCard;